import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();
const originalPush = history.push.bind(history);

history.push = ((pathOrLocation: any, state?: any) => {
  if (typeof pathOrLocation === 'string') {
    return originalPush(pathOrLocation, { fromApp: true, ...(state || {}) });
  }

  return originalPush({
    ...pathOrLocation,
    state: { fromApp: true, ...(pathOrLocation.state || {}) },
  });
}) as typeof history.push;
